import { useEffect, useState } from "react";
import { Container, Form, Row, Button, InputGroup, Alert } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { League } from "../components/LeagueList";

import { useWebsocket } from "../hooks/useWebSocket";
import { LeagueData } from "../types/leagueData";

const API_URL = process.env.REACT_APP_API_URL;

export function Home() {
  const [searchParams] = useSearchParams();
  const {errored, connected, message, send} = useWebsocket(`${API_URL}/leagues/ws`);
  const [leagueID, setLeagueID] = useState<string>(searchParams.get("league_id") ?? "");
  const [leagueState, setLeagueState] = useState<LeagueData | undefined>(undefined);

  // Handle page load and the searchParams being set
  // Trigger when we connect for the first time
  useEffect(() => {
    const initialLeagueID = searchParams.get("league_id");
    if (!initialLeagueID) {
      return;
    }
    sendMessage();
  }, [connected])

  useEffect(() => {
    if (!message) {
      return;
    }
    if (message.type == "update") {
      const data = message.data as LeagueData;
      setLeagueState(data)
    }
  }, [message, setLeagueState]);

  const sendMessage = () => {
    send({
      type: "subscribe",
      data: {
        id: parseInt(leagueID)
      }
    });
  };

  const handleSubmit = (event: React.SubmitEvent) => {
    event.preventDefault();
    sendMessage();
  }

  return <Container>
    {errored && !connected? <Alert variant={"danger"}>Unable to connect to server</Alert> : <></>}
    <Form onSubmit={handleSubmit}>
      <Form.Group as={Row}>
        <InputGroup size="sm" className="mb-3">
          <InputGroup.Text id="leagueInputText">League ID</InputGroup.Text>
          <Form.Control
            aria-label="Small"
            aria-describedby="leagueInputText"
            type="text"
            value={leagueID}
            onChange={(event) => setLeagueID(event.target.value)}
          />
          <Button type="submit">
            Submit
          </Button>
        </InputGroup>
      </Form.Group>
    </Form>
    <Container>
      <h2>{leagueState?.name}</h2>
      <League data={leagueState}/>
    </Container>
  </Container>
}
